// Force Mr. Parker slideshow to rotate automatically
document.addEventListener("DOMContentLoaded", function() {
  const slideshows = document.querySelectorAll('.slideshow');
  slideshows.forEach(slideshow => {
    const nextSlide = () => {
      const active = slideshow.querySelector('.slide.show');
      if (!active) return;
      const next = active.nextElementSibling || slideshow.querySelector('.slide:first-child');
      active.classList.remove('show');
      next.classList.add('show');
    };
    setInterval(nextSlide, 5000); // change 5000 to slide duration (ms)
  });
});
